export const usePammAgentOffers = () => ({
    loading: true,
    pammAgentOffers: []
    //   {
    //     name: 'Test Offer Mid Length Name goes here but not extremely long'
    //   }
    // ],
  })
